module.exports = __webpack_public_path__ + "img/智商@2x.3247f2a1.png";